import { useEffect, useState } from 'react';
import { CalendarDays, Clock } from 'lucide-react';

const IST_OFFSET_MS = 5.5 * 60 * 60 * 1000;

function nowInIst(): Date {
  return new Date(Date.now() + IST_OFFSET_MS);
}

function formatDate(d: Date): string {
  const day = d.getUTCDate();
  const month = d.toLocaleString('en-GB', { month: 'short', timeZone: 'UTC' });
  const weekday = d.toLocaleString('en-GB', {
    weekday: 'short',
    timeZone: 'UTC',
  });
  return `${weekday}, ${day} ${month}`;
}

function formatTime(d: Date): string {
  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mm = String(d.getUTCMinutes()).padStart(2, '0');
  const ss = String(d.getUTCSeconds()).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}

export function TopbarClock() {
  const [ist, setIst] = useState<Date>(() => nowInIst());

  useEffect(() => {
    const id = setInterval(() => setIst(nowInIst()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="hidden h-10 items-center gap-3 rounded-xl border border-border/70 bg-gradient-to-br from-white/80 to-secondary/40 px-3.5 text-sm shadow-card md:inline-flex">
      <div className="flex items-center gap-2 text-muted-foreground">
        <CalendarDays className="h-4 w-4 text-primary-600" />
        <span className="font-medium text-foreground">{formatDate(ist)}</span>
      </div>
      <span className="h-5 w-px bg-border" />
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4 text-primary-600" />
        <span className="font-mono text-sm font-semibold tabular-nums text-foreground">
          {formatTime(ist)}
        </span>
        <span className="rounded-md bg-primary-50 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-primary-700">
          IST
        </span>
      </div>
    </div>
  );
}
